import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../redux/store';

// Use em todo o app em vez de useDispatch simples
export const useAppDispatch = () => useDispatch<AppDispatch>();
